import { AxiosError } from "axios";

import { config, getBaseUrl } from "@config";

import { errorCodes } from "@api/interceptors/constants";
import { InterceptorErrorHandler } from "@api/interceptors/types";
import { useConfigurationStore } from "@stores";

import queryParameters from "@constants/queryParameters";
import { URLS } from "@constants/urls";

export const forbiddenEmptyCustomFields: InterceptorErrorHandler = (error: AxiosError) => {
  const { response } = error;
  const errorId = response?.data?._errors?.[0]?.id;
  const { getState: getConfigurationState } = useConfigurationStore;
  const { setRequiredCustomFields } = getConfigurationState();

  if (response?.status === 403 && errorId === errorCodes["403"].forbidden.emptyCustomFields) {
    setRequiredCustomFields(errorId === errorCodes["403"].forbidden.emptyCustomFields);

    if (!window.location.pathname.includes(URLS.user.profile)) {
      const pathname = window.location.pathname.startsWith("/plus")
        ? window.location.pathname.replace("/plus", "")
        : window.location.pathname;

      const redirectParam = pathname + window.location.search;

      const encodedRedirectParam = encodeURIComponent(redirectParam);

      const queryParam = `?${queryParameters.redirect}=${encodedRedirectParam}`;

      window.location.href = config.isDev()
        ? `${URLS.user.profile}${queryParam}`
        : `${getBaseUrl()}${URLS.user.profile}${queryParam}`;
    }
    return Promise.reject(error);
  }
  return error;
};
